import {
    FILTER_COMPANY,
} from './types';


export const SetFilter = (company) => {
    return {
        type: FILTER_COMPANY,
        payload:company
    };
};




